export default {
  inserted: (el) => {
    function loadImage() {
      const imageElement = Array.from(el.children).find((el) => el.nodeName === 'IMG');

      if (imageElement) {
        imageElement.addEventListener('load', () => {
          setTimeout(() => el.classList.add('loaded'), 100);
        });
        imageElement.addEventListener('error', () => console.log('error'));
        imageElement.src =
          imageElement.dataset.url.replace('cdn-products.chronext.com', 'chronexttime.imgix.net') +
          '?w=90&auto=format&fm=jpg&q=55&usm=50&usmrad=1.5&dpr=2&fit=clamp';
      }
    }

    function handleIntersect(entries, observer) {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          return;
        } else {
          loadImage();
          observer.unobserve(el);
        }
      });
    }

    function handleMutation(entries) {
      entries.forEach((entry) => {
        if (entry.type === 'attributes' && entry.attributeName === 'data-url') {
          entry.target.src =
            entry.target.dataset.url.replace('cdn-products.chronext.com', 'chronexttime.imgix.net') +
            '?w=90&auto=format&fm=jpg&q=55&usm=50&usmrad=1.5&dpr=2&fit=clamp';
        }
      });
    }

    function createIntersectionObserver() {
      const options = {
        root: null,
        threshold: '0',
      };

      const observer = new IntersectionObserver(handleIntersect, options);

      observer.observe(el);
    }
    function createMutationObserver() {
      const mutationConfig = {
        attributes: true,
        childList: true,
        subtree: true,
      };
      const mutationObserver = new MutationObserver(handleMutation);
      mutationObserver.observe(el, mutationConfig);
    }
    if (!window['IntersectionObserver']) {
      loadImage();
    } else {
      createIntersectionObserver();
    }
    if (window['MutationObserver']) {
      createMutationObserver();
    }
  },
};
